import { useEffect, useState } from 'react'
import { setAccessToken } from '../helpers'
import v from '../validators'
import { Params, useNavigate, useParams } from 'react-router-dom'
import { FormControl, Form, Container, Row, Col, FormLabel } from 'react-bootstrap'
import { t } from '../locale'
import KButton from '../components/KButton'

const pendingConfirmTokens = new Set<string>()

function SetPassword(props: any) {
  const navigate = useNavigate()

  const params: Readonly<Params<string>> = useParams()

  const [password, setPassword] = useState('')
  const [repeatPassword, setRepeatPassword] = useState('')
  const [isPasswordValid, setIsPasswordValid] = useState(true)
  const [isRepeatPasswordValid, setIsRepeatPasswordValid] = useState(true)

  const passwordChecks = {
    length: password?.length >= 8,
    uppercase: /[A-Z]/.test(password ?? ''),
    lowercase: /[a-z]/.test(password ?? ''),
    number: /[0-9]/.test(password ?? ''),
    symbol: /[!@#$%^&*]/.test(password ?? ''),
  }

  function isPasswordsEqual() {
    return password === repeatPassword
  }

  function submitPassword() {
    fetch(`${process.env.REACT_APP_API_URL}/user/password-set`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        password: password,
        repeatPassword: repeatPassword,
      }),
    })
      .then(r => r.json())
      .then(r => {
        if (!!r.accessToken) {
          setAccessToken(r.accessToken)
          navigate(
            '/user/pincode-validation/' + (process.env.REACT_APP_ENV === 'dev' ? r.pinCode : '')
          )
        }
      })
  }

  useEffect(() => {
    const accessToken = params.accessToken as string
    setAccessToken(accessToken)
    if (!props.reset && accessToken && !pendingConfirmTokens.has(accessToken)) {
      pendingConfirmTokens.add(accessToken)

      fetch(`${process.env.REACT_APP_API_URL}/user/confirm`)
        .then(r => r.json())
        .then(r => {
          if (!!r.accessToken) {
            setAccessToken(r.accessToken)
          }
        })
        .catch(() => {
          pendingConfirmTokens.delete(accessToken)
        })
    }
  }, [params.accessToken, props.reset])

  function handlePassword(e: any) {
    const value = e.target.value.trim()
    setPassword(value)
    setIsPasswordValid(v.password(value))
  }
  function handleRepeatPassword(e: any) {
    const value = e.target.value.trim()
    setRepeatPassword(value)
    setIsRepeatPasswordValid(value === password)
  }
  function handleSubmit(e: any) {
    e.preventDefault()

    setIsPasswordValid(v.password(password))
    setIsRepeatPasswordValid(isPasswordsEqual())

    if (v.password(password) && isPasswordsEqual()) {
      submitPassword()
    }
  }

  return (
    <>
      {/* Mobile phone top - horizontal navigation */}
      <div className='container-fluid px-sm-5'></div>
      <Container className='overflow-hidden'>
        <Row>
          <Col md={6} className='col-12 mx-auto text-start'>
            <h4 className='mb-2 text-start'>{t('setPassword')}</h4>
            <Form className='needs-validation' onSubmit={handleSubmit} noValidate>
              <div className='mb-3 text-start'>
                <FormLabel htmlFor='password' className='fw-medium smaller text-primary required'>
                  {t('password')}
                </FormLabel>
                <FormControl
                  id='password'
                  type='password'
                  isInvalid={!isPasswordValid}
                  value={password}
                  onChange={handlePassword}
                  autoComplete='new-password'
                  autoFocus
                />
                <div className='mt-2'>
                  <p className='fw-medium smaller text-primary mb-1'>{t('passwordRequirements')}</p>
                  <ul className='list-unstyled mb-0' style={{ fontSize: '0.85rem' }}>
                    <li style={{ color: passwordChecks.length ? 'green' : 'inherit' }}>
                      <i
                        className={
                          passwordChecks.length ? 'bi bi-check-circle-fill' : 'bi bi-circle'
                        }
                      />{' '}
                      {t('passwordReqLength')}
                    </li>
                    <li
                      style={{
                        color:
                          passwordChecks.uppercase && passwordChecks.lowercase
                            ? 'green'
                            : 'inherit',
                      }}
                    >
                      <i
                        className={
                          passwordChecks.uppercase && passwordChecks.lowercase
                            ? 'bi bi-check-circle-fill'
                            : 'bi bi-circle'
                        }
                      />{' '}
                      {t('passwordReqCase')}
                    </li>
                    <li style={{ color: passwordChecks.number ? 'green' : 'inherit' }}>
                      <i
                        className={
                          passwordChecks.number ? 'bi bi-check-circle-fill' : 'bi bi-circle'
                        }
                      />{' '}
                      {t('passwordReqNumber')}
                    </li>
                    <li style={{ color: passwordChecks.symbol ? 'green' : 'inherit' }}>
                      <i
                        className={
                          passwordChecks.symbol ? 'bi bi-check-circle-fill' : 'bi bi-circle'
                        }
                      />{' '}
                      {t('passwordReqSymbol')}
                    </li>
                  </ul>
                </div>
              </div>
              <div className='mb-3 text-start'>
                <label htmlFor='repeatPassword' className='fw-medium smaller text-primary required'>
                  {t('repeatPassword')}
                </label>
                <FormControl
                  id='repeatPassword'
                  type='password'
                  isInvalid={!isRepeatPasswordValid}
                  value={repeatPassword}
                  onChange={handleRepeatPassword}
                  autoComplete='new-password'
                />
              </div>

              <hr className='my-4'></hr>

              <Row className='gx-2'>
                <Col className='col-6 text-start'></Col>
                <Col className='col-6 text-end'>
                  <KButton
                    id='btn-send-pin'
                    type='submit'
                    variant='primary'
                    className='btn text-white'
                    label={t('confirm') + ' »'}
                    onSubmit={handleSubmit}
                  />
                </Col>
              </Row>
            </Form>
          </Col>
        </Row>
      </Container>
    </>
  )
}

export default SetPassword
